module.exports = __webpack_public_path__ + "static/media/cloud-b-v3@2x.14fd760e.png";